export default {
  apiKey: '3577c7bf7dsa7232dsadsd123-670f2eb21c4__',

  /**
   * Production
   *
   */
  apiUri: 'https://contenthub.amway.id/api/v1/',

  /**
   * Development
   *
   */
  // apiUri: 'https://demoapi.amwaypublication.com/api/v1/',

  /**
   * Localhost
   *
   */
  // apiUri: 'http://localhost:4901/api/v1/',

  appName: 'Amway Content Hub',
  uri(uri: string) {
    return `${this.apiUri}${uri}`;
  },
  encrypt(msg: string) {
    // TODO encrypt message here
    return msg;
  },
  appUri: 'https://contenthub.amway.id/',
};
